<div class="tab-content">
  <div class="payment-layout">
    <fieldset class="rms-fieldset payment-fields">
      <legend>Payment Preferences</legend>
      <div class="payment-grid">
        <div class="field">
          <label>Preferred Method</label>
          <rms-select
            name="PaymentMethodID"
            [disabled]="!canEdit"
            [options]="PaymentMethods"
            labelKey="MethodName"
            valueKey="PaymentMethodID"
            [(ngModel)]="Preference.PaymentMethodID"
            (ngModelChange)="savePreference()"
          ></rms-select>
        </div>
        <div class="field">
          <label>Payment Terms</label>
          <rms-select
            name="PaymentTermId"
            [disabled]="!canEdit"
            [options]="PaymentTerms"
            labelKey="PaymentTermName"
            valueKey="PaymentTermId"
            [(ngModel)]="Preference.PaymentTermId"
            (ngModelChange)="savePreference()"
          ></rms-select>
        </div>
        <div class="field credit-limit-field">
          <label>Credit Limit</label>
          <rms-input
            name="CreditLimit"
            [disabled]="!canEdit || isCashTerm"
            type="currency"
            [(ngModel)]="Preference.CreditLimit"
            (ngModelChange)="savePreference()"
          ></rms-input>
          @if(isCashTerm){<div class="cash-term-note">Not applicable for cash terms</div>}
        </div>
        <div class="field">
          <label>Invoice Recipient</label>
          <div>{{ Preference.InvoiceEmail || "—" }}</div>
        </div>
        <div class="field">
          <label>ACH Authorization Recipient</label>
          <div class="field-with-edit">
            <span>{{ Preference.ACHAuthorizationRecipientEmail || "—" }}</span>
            <mat-icon
              class="inline-edit-icon"
              [class.disabled]="!canEdit"
              (click)="openEditForm()"
              >edit</mat-icon
            >
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset class="rms-fieldset accounting-summary">
      <legend>Accounting Summary</legend>
      <div class="summary-box">
        <label>AR Balance</label>
        <div class="summary-value">
          {{
            Preference.ARBalance != null
              ? (Preference.ARBalance | currency)
              : "—"
          }}
        </div>
      </div>
      <div class="summary-box">
        <label>Past Due</label>
        <div class="summary-value">
          {{
            Preference.PastDueAmount != null
              ? (Preference.PastDueAmount | currency)
              : "—"
          }}
        </div>
      </div>
      <p class="ar-note">
        Accounting-owned values are read-only in Customer Management.
      </p>
    </fieldset>
  </div>
</div>
